import axios from "axios";
import { BACKEND_URL } from "../../../utils/api";

export interface DashboardAuditLog {
  id: string;
  actor_id: string | null;
  actor_email: string | null;
  actor_name: string | null;
  actor_role: string | null;
  action: string;
  module: string;
  resource_type: string | null;
  resource_id: string | null;
  target_user_id: string | null;
  description: string | null;
  details: Record<string, unknown> | string | null;
  ip_address: string | null;
  created_at: string | null;
}

export interface DashboardAuditListResponse {
  items: DashboardAuditLog[];
  total: number;
  skip: number;
  limit: number;
}

export const dashboardAuditService = {
  async list(
    token: string,
    params?: {
      skip?: number;
      limit?: number;
      module?: string;
      action?: string;
      search?: string;
    }
  ): Promise<DashboardAuditListResponse> {
    const response = await axios.get(`${BACKEND_URL}/dashboard-audit`, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });
    return response.data.data as DashboardAuditListResponse;
  },
};
